import { BaseModel } from '../base.model';
import {required} from '../json-map.util';

class TopicRequest {}

namespace TopicRequest {


  export class Create extends BaseModel {

    @required()
    displayName: string = undefined;

    @required()
    subject: string = undefined;

    @required()
    tier1: string = undefined;
    @required()
    tier2: string = undefined;

    tier3: string = undefined;
    tier4: string = undefined;

    strategyName: string = undefined;
    strategyDescription: string = undefined;

  }

  export class Update extends BaseModel {

    displayName: string = undefined;
    subject: string = undefined;
    tier1: string = undefined;
    tier2: string = undefined;
    tier3: string = undefined;
    tier4: string = undefined;
    strategyName: string = undefined;
    strategyDescription: string = undefined;

  }

  export class Seeder extends BaseModel {
    name: string = undefined;
    subject: string = undefined;
    tier1: string = undefined;
    tier2: string = undefined;
    tier3: string = undefined;
    tier4: string = undefined;
  }


}

export { TopicRequest };

